export default {
  /**
   * Handle log messages and log them to the browser/nodejs console
   * @param  {number} level   The log level of the message
   * @param  {mixed}  message The log message to be logged
   * @param  {object} logger  The logger that handled the message
   */
  log: function (level, message, logger) {
    throw new Error('Objects extending the abstract logging driver must provide a log method');
  },

  /**
   * Handle errors and log them
   * @param  {Error}  error   The error to be logged
   * @param  {object} logger  The logger that handled the message
   */
  logException: function (error, logger) {
    let message;
    if (typeof error.getMessage === 'function') {
      message = error.getMessage();
    } else {
      message = error.message;
    }
    return this.log(logger.ERROR, message, logger);
  }
};
